import { Switch, styled } from "@mui/material";
const PinkSwitch = styled(Switch)(({ theme }) => ({
  "&.MuiSwitch-root": {
    zIndex: -1,
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#25D5A1",
    zIndex: -1,
    "&:hover": {
      // backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#25D5A1",
  },
}));

const label = { inputProps: { "aria-label": "Toggle" } };

function ToggleSwitch(props) {
  const { checked = false, status, onChange = null } = props;
  return (
    <PinkSwitch
      {...label}
      defaultChecked={checked}
      checked={checked}
      onChange={(event) => {
        if (onChange) {
          onChange(event);
        }
      }}
    />
  );
}
export default ToggleSwitch;
